module.exports = __webpack_public_path__ + "img/expired.98bf89d8.png";